import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface BannerRecircDefaultIntegrityProps {
    items?: CuratedItem[];
}

const MIN_ITEMS = 4;

export default function integrityCheck({
    items,
}: BannerRecircDefaultIntegrityProps): IntegrityStatus {
    const messages = [];

    if (!items || items?.length < MIN_ITEMS) {
        messages.push("Minimal number of items is not met");
    }

    return [...messages, ...checkItemArrayIntegrity(items, ["image"])];
}
